module.exports = __webpack_public_path__ + "static/img/jx.a79228c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/jx.png
// module id = fo3y
// module chunks = 93